<template lang="pug">
.features(id="feature")
  h2 强大的产品特性
  .container
    .feature-item(v-for="feature in featureData")
      .function-logo(:class="feature.logo")
      .feature-header {{ feature.header }}
      p {{ feature.content }}
</template>

<script>
export default {
  name: 'features',
  data() {
    return {
      featureData: [
        {
          header: '智能调度',
          logo: 'coalesce',
          content: '用户可根据自身需求，配置接入的各 CDN 厂商，融合各家资源，按任意比例配置调度各厂商间的流量，统一管理操作。'
        }, {
          header: '超融合',
          logo: 'dispatch',
          content: '自动探测各接入 CDN 厂商的节点信息，统筹分析相互结合，使每个域名都能达到在不同地区不同运营商都有本地化节点覆盖。'
        }, {
          header: '自动容灾',
          logo: 'disaster',
          content: '实时监测各接入 CDN 厂商的节点服务情况，如某个节点有问题，则自动剔除并切换到其他厂商节点，保障业务的正常服务。'
        }, {
          header: '实时监控',
          logo: 'monitor',
          content: '监测数据实时上报，并且会通过邮件、短信、电话等多维度进行告警通知，帮助您在第一时间掌握域名的运行状况。'
        }
      ]
    }
  }
}
</script>

<style lang="sass" scoped>
h2
  text-align: center
  margin-bottom: 66px

.features
  padding: 123px 0

.container
  display: flex
  width: 1170px
  margin: 0 auto
  flex-direction: row
  justify-content: space-between

.feature-item
  width: 250px
  flex-shrink: 1
  .function-logo
    height: 180px
    width: 100%
    background-repeat: no-repeat
    background-position: center
    &.coalesce
      background-image: url('../assets/features/coalesce.svg')
    &.dispatch
      background-image: url('../assets/features/dispatch.svg')
    &.disaster
      background-image: url('../assets/features/disaster.svg')
    &.monitor
      background-image: url('../assets/features/monitor.svg')
  .feature-header
    line-height: 3.5em
    font-size: 16px
    color: #333333
    text-align: center
  p
    font-size: 14px
    color: #666666
    text-align: justify
</style>



// WEBPACK FOOTER //
// features.vue?cd427136